import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Page404 from './components/Page404';
import Page401 from './components/Page401';
import Anvandavillkor from './components/Anvandavillkor';
import Dataskyddspolicy from './components/Dataskyddspolicy';
import Integritetspolicy from './components/Integritetspolicy';
import Checkout from './components/Checkout';
import Complete from './components/Complete';
import Plans from './components/Plans';
import Account from './components/Account';
import BookingAutomation from './components/BookingAutomation';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Routes with standard header/footer */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/account" element={<Account />} />
            <Route path="/bokning" element={<BookingAutomation />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/complete" element={<Complete />} />
            <Route path="/anvandavillkor" element={<Anvandavillkor />} />
            <Route path="/dataskyddspolicy" element={<Dataskyddspolicy />} />
            <Route path="/integritetspolicy" element={<Integritetspolicy />} />
            <Route path="/401" element={<Page401 />} />
            <Route path="*" element={<Page404 />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
